/* ============================================================
   StratOS Premium Theme — Global Bootstrap
   Provides: window.pubsub, window.ShopUtils
   Budget: ≤ 10kb minified
   ============================================================ */

(function () {
  'use strict';

  /* ── PubSub — ne pas réinitialiser si déjà défini par le <head> inline ── */
  if (!window.pubsub) {
    const subscribers = {};
    window.pubsub = {
      subscribe(event, fn) {
        if (!subscribers[event]) subscribers[event] = [];
        subscribers[event].push(fn);
        return function unsubscribe() {
          subscribers[event] = subscribers[event].filter(function (s) { return s !== fn; });
        };
      },
      publish(event, data) {
        if (!subscribers[event]) return;
        subscribers[event].forEach(function (fn) { fn(data); });
      }
    };
  }

  /* ── ShopUtils ── */
  window.ShopUtils = {
    formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var value = (cents / 100).toFixed(2);
      var moneyFormat = format
        || window.shopMoneyFormat
        || '{{amount_with_comma_separator}} €';
      return moneyFormat
        .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
        .replace('{{amount}}', value);
    },

    fetchCart() {
      return fetch('/cart.js', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) { return res.json(); });
    },

    addToCart(variantId, quantity) {
      quantity = quantity || 1;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return window.ShopUtils.fetchCart();
        })
        .then(function (cart) {
          window.pubsub.publish('cart:updated', cart);
          return cart;
        });
    },

    changeCart(key, quantity) {
      /* Sérialisation des requêtes via une queue Promise globale.
         Shopify retourne 409 si une opération cart est déjà en cours. */
      if (!window.ShopUtils._cartQueue) {
        window.ShopUtils._cartQueue = Promise.resolve();
      }

      var attempt = function (retries) {
        retries = retries || 0;
        return fetch('/cart/change.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: key, quantity: quantity })
        })
        .then(function (res) {
          if (res.status === 409 && retries < 3) {
            /* Attente exponentielle avant retry : 150ms, 300ms, 600ms */
            return new Promise(function (resolve) {
              setTimeout(resolve, 150 * Math.pow(2, retries));
            }).then(function () { return attempt(retries + 1); });
          }
          if (!res.ok) throw new Error('cart/change.js ' + res.status);
          return res.json();
        })
        .then(function (data) {
          window.pubsub.publish('cart:updated', data);
          return data;
        });
      };

      /* Chaîner dans la queue : chaque appel attend la fin du précédent */
      window.ShopUtils._cartQueue = window.ShopUtils._cartQueue
        .then(function ()  { return attempt(); })
        .catch(function () { return attempt(); }); /* on relance sur erreur réseau */

      return window.ShopUtils._cartQueue;
    },

    debounce(fn, ms) {
      var timer;
      return function () {
        var context = this;
        var args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, ms);
      };
    }
  };

  /* ── Global modal trigger delegation ── */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-modal-open]');
    if (!trigger) return;
    var modalId = trigger.getAttribute('data-modal-open');
    if (modalId) {
      window.pubsub.publish('modal:open', { id: modalId, trigger: trigger });
    }
  });

  /* ── Localisation picker (custom <details> dropdown) ── */
  (function () {
    document.addEventListener('click', function (e) {
      /* Sélection pays */
      var countryBtn = e.target.closest('[data-loc-country]');
      if (countryBtn) {
        var form  = countryBtn.closest('form');
        if (!form) return;
        var input = form.querySelector('[data-loc-country-input]');
        if (input) input.value = countryBtn.dataset.locCountry;
        countryBtn.closest('details').removeAttribute('open');
        form.submit();
        return;
      }

      /* Sélection langue */
      var langBtn = e.target.closest('[data-loc-language]');
      if (langBtn) {
        var form  = langBtn.closest('form');
        if (!form) return;
        var input = form.querySelector('[data-loc-language-input]');
        if (input) input.value = langBtn.dataset.locLanguage;
        langBtn.closest('details').removeAttribute('open');
        form.submit();
        return;
      }

      /* Fermer les autres pickers si on en ouvre un */
      var openedDetails = e.target.closest('.loc-picker');
      document.querySelectorAll('.loc-picker[open]').forEach(function (d) {
        if (d !== openedDetails) d.removeAttribute('open');
      });
    });

    /* Fermer au clic extérieur */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.loc-picker')) {
        document.querySelectorAll('.loc-picker[open]').forEach(function (d) {
          d.removeAttribute('open');
        });
      }
    });

    /* Fermer à l'Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.loc-picker[open]').forEach(function (d) {
          d.removeAttribute('open');
          var s = d.querySelector('summary');
          if (s) s.focus();
        });
      }
    });
  })();

  /* ── Accordéons <details> : sync aria-expanded sur <summary> ── */
  (function () {
    function syncAriaExpanded(details) {
      var summary = details.querySelector('summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    }

    function initDetails(details) {
      syncAriaExpanded(details);
      details.addEventListener('toggle', function () { syncAriaExpanded(details); });
    }

    /* Initialiser tous les <details> existants */
    document.querySelectorAll('details').forEach(initDetails);

    /* Observer les futurs <details> injectés dynamiquement */
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'DETAILS') initDetails(node);
          node.querySelectorAll && node.querySelectorAll('details').forEach(initDetails);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
})();
